
import MarketplaceForProsSection from '../section';
import MarketplaceForProsCard from './card';
import Gutter from '@/ui-kit/components/gutter';
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import {
  StyleSizeType,
  StylePositionType,
} from '@/ui-kit/styles/enums';
import MarketplaceForProsStoreName from '@/store/marketplace-for-pros/name';

export default {
  name: 'MarketplaceForProsCardSection',
  components: {
    MarketplaceForProsSection,
    MarketplaceForProsCard,
    Typography,
    Gutter,
  },
  data() {
    return {
      TypographyType,
      StyleSizeType,
      StylePositionType,
    };
  },
  computed: {
    content() {
      return this.$store.state[MarketplaceForProsStoreName].cardContent;
    },
    title() {
      return this.$store.state[MarketplaceForProsStoreName].cardTitle;
    },
  },
};
